import { GET_TIERING_REQUEST, GET_TIERING_SUCCESS, GET_TIERING_FAILED } from '../types';

import { combineReducers } from 'redux';

const IntialState = {
  loading: false,
  status: null,
  message: null,
  response: {},
  tier: null,
  isError: false,
};

const tierDetails = (state = IntialState, action) => {
  const { type, response: res, message } = action;
  switch (type) {
    case GET_TIERING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TIERING_SUCCESS:
      return {
        ...state,
        status: res.status,
        response: res.data?.content,
        tier: res.data?.tier.toLowerCase(),
        loading: false,
        isError: false,
      };
    case GET_TIERING_FAILED:
      return {
        ...state,
        message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const user = combineReducers({
  tierDetails,
});
export default user;
